module.exports = __webpack_public_path__ + "static/img/chart.e9180b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/views/gallery/chart.png
// module id = 6HLj
// module chunks = 1